import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemeService } from '@caslink/common-client/ng-app/theme/ThemeService';

@Component({
	selector: 'cl-toggler',
	templateUrl: './toggler.component.html',
	styleUrls: ['./toggler.component.scss'],
})
export class TogglerComponent {
    static $name = 'clToggler';

    @Input() activeButtonText = 'CLOSE';
    @Input() inactiveButtonText = 'OPEN';
    @Input() buttonDescription = '';
    @Input() activeMaterialIcon: string;
    @Input() inactiveMaterialIcon: string;
    @Input() isActive: boolean;
    @Input() inactiveRotate: boolean;
    @Output() clickAction = new EventEmitter();

    constructor(private themeService: ThemeService) {}

    toggleIsActive() {
        this.isActive = !this.isActive;
        this.clickAction.emit();
    }

    isDarkTheme() {
        return this.themeService.getTheme() === 'casDark';
    }

    get buttonText() {
        const text = this.isActive ?
            `${this.activeButtonText} ${this.buttonDescription}`:
            `${this.inactiveButtonText} ${this.buttonDescription}`;
        return text.toUpperCase();
    }

    get icon() {
        return this.isActive ? this.activeMaterialIcon : this.inactiveMaterialIcon;
    }

    get rotateIcon() {
        return !this.isActive && this.inactiveRotate;
    }
}
